import React from 'react';

import Tooltip from '../../library/tooltip/tooltip';
import Typography from '../../library/typography/typography';
import RatingsChart from '../ratings-chart/ratings-chart';

import { Maybe } from '../../shared/types/graphql-types';

import './treadwell-bar-row.scss';

export enum TreadwellBarRowColor {
  BLUE = 'blue',
  GREEN = 'green',
  GREY = 'grey',
  GREY_BLUE = 'greyblue'
}

interface TreadwellBarRowInterface {
  barColor?: TreadwellBarRowColor;
  className?: string;
  icon?: () => React.ReactElement;
  maxRatingLabel?: string;
  midRatingLabel?: string;
  minRatingLabel?: string;
  title?: Maybe<string>;
  tooltip?: Maybe<string>;
  value: number;
}

function TreadwellBarRow(props: TreadwellBarRowInterface) {
  const {
    barColor = TreadwellBarRowColor.GREY,
    className = '',
    icon: Icon,
    maxRatingLabel,
    midRatingLabel,
    minRatingLabel,
    title,
    tooltip,
    value
  } = props;
  const ratingsChartStyleName = `ratings-chart ${barColor}`;

  return (
    <div className={`treadwell-bar-row ${className}`} styleName="container">
      {title && (
        <div className="treadwell-bar-row__title" styleName="title">
          {Icon && <Icon styleName="icon" />}
          <Typography weight="heavy">{title}</Typography>
          {tooltip && <Tooltip content={tooltip} styleName="tooltip" />}
        </div>
      )}
      <RatingsChart
        hideLegendNumbers
        styleName={ratingsChartStyleName}
        value={value}
      />
      <div styleName="ratings-label-container">
        {minRatingLabel && <Typography>{minRatingLabel}</Typography>}
        {midRatingLabel && <Typography>{midRatingLabel}</Typography>}
        {maxRatingLabel && <Typography>{maxRatingLabel}</Typography>}
      </div>
    </div>
  );
}

export default TreadwellBarRow;
